
(function(){
if(window.alisenedFbtPlacement){window.alisenedFbtPlacement();return;}
var queued=false;
function configureCheckout(){
var api=window.codeblackbelt&&window.codeblackbelt['frequently-bought-togetherApi'];
var preferences=api&&api.readPreferences();
if(!preferences)return;
preferences.themeDefaultPolicy=false;
preferences.dontRedirectPolicy=false;
preferences.redirectToCartPagePolicy=false;
preferences.redirectToCheckoutPolicy=true;
preferences.addToCartButtonPreferences.label='CHECK OUT NOW';
}
document.addEventListener('click',function(event){
if(event.target.closest('[data-alisened-fbt-slot] .cbb-frequently-bought-add-button'))configureCheckout();
},true);
function place(){
queued=false;
var slot=document.querySelector('[data-alisened-fbt-slot]');
if(!slot)return;
var widget=document.querySelector('.cbb-frequently-bought-container');
if(widget){
configureCheckout();
widget.querySelectorAll('.cbb-frequently-bought-plus-icon').forEach(function(icon){icon.style.setProperty('display','none','important');});
var products=Array.from(widget.querySelectorAll('.cbb-frequently-bought-products .cbb-frequently-bought-product'));
products.forEach(function(product,index){
var next=product.nextElementSibling;
if(index<products.length-1&&(!next||!next.hasAttribute('data-alisened-fbt-plus'))){
var plus=document.createElement('span');
plus.setAttribute('data-alisened-fbt-plus','');
plus.setAttribute('aria-hidden','true');
plus.textContent='+';
plus.style.cssText='display:flex!important;align-items:center!important;justify-content:center!important;align-self:center!important;flex:0 0 18px!important;width:18px!important;height:24px!important;font-size:22px!important;line-height:1!important;color:#183b32!important;margin:0!important;padding:0!important;position:static!important;';
product.after(plus);
}
});
var nativeMessage=widget.querySelector('.cbb-frequently-bought-discount-message-container');
if(nativeMessage)nativeMessage.style.setProperty('display','none','important');
var title=widget.querySelector('.cbb-frequently-bought-title');
if(title){
var message=widget.querySelector('[data-alisened-bundle-offer]');
if(!message){
message=document.createElement('p');
message.setAttribute('data-alisened-bundle-offer','');
message.textContent='Buy Together & Get 20% Off Each';
message.style.cssText='color:#e60000;font-size:16px;font-weight:600;line-height:1.5;margin:0 0 26px;overflow-wrap:anywhere;';
title.style.setProperty('margin-bottom','12px','important');
title.after(message);
}
}
var button=widget.querySelector('.cbb-frequently-bought-add-button');
var label=button&&button.querySelector('span');
if(label&&label.textContent!=='CHECK OUT NOW'&&!button.disabled){label.textContent='CHECK OUT NOW';}
var list=widget.querySelector('.cbb-frequently-bought-selector-list');
var form=widget.querySelector('.cbb-frequently-bought-form');
if(list&&form&&form.firstElementChild!==list){form.insertBefore(list,form.firstElementChild);}
}
if(widget&&!slot.contains(widget)){slot.appendChild(widget);requestAnimationFrame(function(){window.dispatchEvent(new Event('resize'));});}
}
function schedule(){if(!queued){queued=true;requestAnimationFrame(place);}}
window.alisenedFbtPlacement=schedule;
new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',schedule);
schedule();
})();
